<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="contract"
            class="mr-2"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1">
            Ugovor
          </v-toolbar-title>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>Info</v-tab>
              <v-tab>Restrikcije</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text class="pa-0 ma-0" style="height: 30rem;">
          <div class="master_grid">
            <div>
              <v-tabs-items v-model="active_tab">
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-text-field
                          v-model="item.referenca"
                          outlined
                          label="Broj ugovora"
                          required
                          maxlength="50"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-5 pt-1 pb-0">
                        <webpage_lookup_klijenti
                          update="wp_client_changed"
                          :selected_id="item.klijent_id"
                        ></webpage_lookup_klijenti>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-2">
                        <v-dialog
                          ref="vrijedi_od"
                          v-model="show_valid_from"
                          :return-value.sync="item.traje_od"
                          persistent
                          key="1"
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="valid_from_formatted"
                              label="Ugovor vrijedi od"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              outlined
                              hide-details
                              v-bind="attrs"
                              v-on="on"
                              :width="80"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.traje_od"
                            @change="save_valid_from"
                            locale="bs-bs"
                            :first-day-of-week="1"
                            :show-week="true"
                          >
                          </v-date-picker>
                        </v-dialog>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-2">
                        <v-dialog
                          ref="vrijedi_do"
                          key="2"
                          v-model="show_valid_to"
                          :return-value.sync="item.valid_to"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="valid_to_formatted"
                              label="Ugovor vrijedi do"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              outlined
                              hide-details
                              v-bind="attrs"
                              v-on="on"
                              :width="80"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.traje_do"
                            @change="save_valid_to"
                            locale="bs-bs"
                            :first-day-of-week="1"
                            :show-week="true"
                          >
                          </v-date-picker>
                        </v-dialog>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-textarea
                          v-model="item.description"
                          outlined
                          clearable
                          label="Opis ugovora"
                          maxlength="500"
                          counter
                        ></v-textarea>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-1 pt-1">
                        <v-text-field
                          v-model.number="item.financial_value"
                          outlined
                          label="Vrijednost ugovora"
                          type="number"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-switch
                        hide-details
                        v-model="item.active"
                        label="Aktivan"
                      ></v-switch>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="is_btn_loading" text @click="save_item()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_klijenti: () => import("@/components/lookups/klijenti"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    is_loading: true,
    is_btn_loading: false,
    active_tab: 0,
    show_valid_from: null,
    show_valid_to: null,
    item: {
      naziv: null,
      id: 0,
      klijent_id: null,
      account_id: null,
      referenca: null,
      description: null,
      traje_od: null,
      traje_do: null,
      active: true,
      financial_value: null,
    },
    title: "Evidencija novog ugovora",
    visible: false,
  }),
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  computed: {
    valid_from_formatted() {
      return this.item.traje_od
        ? this.$moment(this.item.traje_od)
            .format("DD MMMM YYYY")
            .toString()
        : null;
    },
    valid_to_formatted() {
      return this.item.traje_do
        ? this.$moment(new Date(this.item.traje_do)).format("DD MMMM YYYY")
        : null;
    },
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_item();
        } else {
          this.item = {
            id: 0,
            naziv: null,
            klijent_id: null,
            account_id: null,
            referenca: null,
            description: null,
            traje_od: null,
            traje_do: null,
            active: true,
            financial_value: null,
          };
          this.is_loading = false;
        }
      },
      immediate: false,
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (this.item.referenca == null || this.item.referenca.length == 0) {
          has_errors = true;
          reject("Broj ugovora polje je obavezno.");
        }
        if (this.item.klijent_id == null || this.item.klijent_id.length == 0) {
          has_errors = true;
          reject("Klijent polje je obavezno.");
        }
        if (this.item.traje_od == null || this.item.traje_od.length == 0) {
          has_errors = true;
          reject("Ugovor vrijedi od polje je obavezno.");
        }
        if (this.item.traje_do == null || this.item.traje_do.length == 0) {
          has_errors = true;
          reject("Ugovor vrijedi do polje je obavezno.");
        }
        if (
          this.item.financial_value > 999999999999.99 ||
          this.item.financial_value < 0
        ) {
          has_errors = true;
          reject("Vrijednost ugovora nije ispravna");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_client_changed", (client) => {
        if (client !== null) {
          this.item.naziv = client.naziv;
          this.item.klijent_id = client.id;
        }
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_client_changed");
    },
    save_valid_from() {
      this.$refs.vrijedi_od.save(this.item.traje_od);
    },
    save_valid_to() {
      this.$refs.vrijedi_do.save(this.item.valid_to);
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_contract"
      );
    },
    get_item() {
      this.$http({
        method: "GET",
        url: "/ugovori/get_contract/" + this.id,
      }).then((resp) => {
        this.item = resp.data.result[0];
        this.is_loading = false;
        this.item.traje_od = this.$moment(new Date(this.item.traje_od)).format(
          "YYYY-MM-DD HH:SS"
        );
        this.item.traje_do = this.$moment(new Date(this.item.traje_do)).format(
          "YYYY-MM-DD HH:SS"
        );
      });
    },
    save_item() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.item.account_id = this.$store.getters.user.account_id;
          this.$http({
            method: "POST",
            url: "/contract/update",
            data: this.item,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Ugovor je evidentiran",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_contract");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_btn_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
};
</script>

<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}
</style>
